import { applyMiddleware, compose, createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'

import { routerHistory, routerConnect, routerMiddleware } from '@modules/router'
import getRootReducer from './reducers'
import { combineSagas } from './sagas'
import { getInitialState } from './state'

export const config: Object = {
  key: 'damm',
  storage: storage,
  blacklist: 'router'
}

const composeEnhancers = process.env.NODE_ENV === 'development'
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose
export const sagasMiddleware = createSagaMiddleware()
export const store = createStore(
  persistReducer(config, routerConnect(routerHistory)(getRootReducer())),
  getInitialState(),
  composeEnhancers(
    applyMiddleware(sagasMiddleware),
    applyMiddleware(routerMiddleware(routerHistory))
  )
)
export const persistor = persistStore(store)

sagasMiddleware.run(combineSagas)

export default () => ({
  store,
  persistor
})
